// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"be103382","107":"ea7d1fe3","393":"783ac428"}[chunkId] + ".chunk.js";
};